export default {
  amount: {
    id: 'bo_seller.insights.financial_report.amount',
    defaultMessage: 'Amount',
  },
  percentage: {
    id: 'bo_seller.insights.financial_report.percentage_title',
    defaultMessage: '%',
  },
  yearOnYear: {
    id: 'bo_seller.insights.financial_report.year_on_year',
    defaultMessage: 'Year on Year',
  },
}
